<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelGame"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option }"
      ><span class="badge badge-primary mr-1"
        ><span class="text-truncate mr-1 mb-1">{{ option.nome }}</span
        ><span class="custom__remove badge" @mousedown.prevent.stop="removeOption(option)">x</span></span
      ></template
    >
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble',
    'alreadyAdded',
    'siteSelected',
    'requireSite'
  ],

  data() {
    return {
      selected: [],
      value: [],
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'game', null);
        return;
      }
      this.$emit('selectChange', 'game', e);
    },
    labelGame({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (this.isTagabble) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'game', value);
      } else {
        if (value) {
          if (value.id) {
            this.selected = this.options.find((option) => option.id === value.id);
          } else {
            this.selected = this.options.find((option) => option.id === value);
          }
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
        this.$emit('input', this.selected);
      }
    },
    clearAll() {
      this.value = [];
    },
    setOptions(site) {
      this.isLoading = true;
      let filtro = '';
      if (site) {
        filtro += `id_localidade_web = ${site} OR ids_localidade_web IS NOT NULL AND ('['||ids_localidade_web||']')::jsonb @> '[${site}]'`;
      }
      this.$atenaList
        .getCommon('game', {
          columns: 'id_game as id,nome_game as nome',
          filter: filtro,
          order: 'id'
        })
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          if (this.alreadyAdded) {
            this.removeOptions(this.alreadyAdded);
          }
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    removeOptions(options) {
      if (!options) return;
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.id === element.id);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.id === option.id);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.id != el.id);
        }
      });

      this.setValue(valueCp);
      this.options = [option, ...this.options];
    }
  },
  created() {
    if (!this.requireSite) {
      if (this.siteSelected) this.setOptions(this.siteSelected);
      else this.setOptions();
    }
  },
  watch: {
    siteSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
        this.onChange();
      }
    },
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__remove {
  background: #26b4ff !important;
  color: #fff;
  transition: ease 0.2s all;
}

.custom__remove:hover {
  cursor: pointer;
  background: #0097e9 !important;
}
</style>
